import { Injectable } from "@angular/core";
import { StaffRequirementAttachmentsService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { RequirementAttachmentsPort } from "../../../app/ports/requirement/requirement-attachments.port";
import { RequirementAttachment, RequirementAttachmentListRequest, RequirementAttachmentRequest } from "../../../domain/models/requirement/requirement-attachment.model";
import { mapRequirementAttachment } from "../../mappers/requirement/requirement-attachment.mapper";

@Injectable({ providedIn: "root" })
export class RequirementAttachmentsPortAdapter implements RequirementAttachmentsPort {
  constructor(private readonly api: StaffRequirementAttachmentsService) {}

  list(id: number, request: RequirementAttachmentListRequest = {}): Observable<readonly RequirementAttachment[]> {
    return this.api.list(id, request).pipe(map(({ data }) => data.map(mapRequirementAttachment)));
  }

  create(id: number, request: RequirementAttachmentRequest): Observable<RequirementAttachment> {
    return this.api.create(id, request).pipe(map(({ data }) => mapRequirementAttachment(data)));
  }

  delete(id: number, attachmentId: number): Observable<void> {
    return this.api.delete(id, attachmentId).pipe(map(() => undefined));
  }
}
